import React from 'react';


export const Report = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M12.984 12.984v-6h-1.969v6h1.969zM12 17.297c0.703 0 1.313-0.609 1.313-1.313s-0.609-1.266-1.313-1.266-1.313 0.563-1.313 1.266 0.609 1.313 1.313 1.313zM15.75 3l5.25 5.25v7.5l-5.25 5.25h-7.5l-5.25-5.25v-7.5l5.25-5.25h7.5z" />
  </svg>);
